import type { ReactElement } from 'react';

import { XIcon } from '@phosphor-icons/react';
import { useRouter } from 'next/compat/router';

import { AF } from './styles';
import { FesLink } from '~/components/shared/core/link/FesLink';
import { useProductListContext } from '~/utilities/context/static/ProductListContext';
import type { SelectedFacetV2 } from '~/utilities/graphql/codegen';

type AppliedSOLRFacetProps = {
  facet: SelectedFacetV2;
};

export const AppliedSOLRFacet = ({ facet }: AppliedSOLRFacetProps): ReactElement => {
  const { categoryDetails: { clearAllUrl, visibleFacetsV2 } = {} } = useProductListContext();
  const facetAppliedValue = facet.facetValues?.at(0)?.code;
  const router = useRouter();
  const [, queryString] = (router?.asPath ?? '').split('?');
  const clearUrlFromVisibleFacet = visibleFacetsV2
    ?.find(visibleFacet => visibleFacet?.code === facet.code)
    ?.facetValues?.find(value => value?.code === facetAppliedValue)?.url;

  const clearUrl = clearUrlFromVisibleFacet || facet.removeUrl || clearAllUrl;

  const url = queryString ? `${clearUrl}?${queryString}` : clearUrl!;

  return (
    <AF.AppliedFilter
      as={FesLink}
      data-testid={`applied-filter-${facet.code}`}
      href={url}
      scroll={false}
    >
      <AF.AppliedFilterLabel>{facetAppliedValue}</AF.AppliedFilterLabel>

      <AF.RemoveAppliedIconWrapper>
        <XIcon />
      </AF.RemoveAppliedIconWrapper>
    </AF.AppliedFilter>
  );
};
